import { render, staticRenderFns } from "./CompraDiretaLegadaDetalhesResultado.vue?vue&type=template&id=bd4f9de4&scoped=true"
import script from "./CompraDiretaLegadaDetalhesResultado.vue?vue&type=script&lang=js"
export * from "./CompraDiretaLegadaDetalhesResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4f9de4",
  null
  
)

export default component.exports